
export default {
  props: {
    selectedVariant: { type: Object, default: () => {} },
  },

  computed: {
    allPdpVideos() {
      const videoSrc = this.selectedVariant?.external_video;
      return (videoSrc || []).map(url => ({ src: url }));
    },
  },
};
